export const IOC_DETECTIONS_LIST_SET = 'IOC_DETECTIONS_LIST_SET'
export const IOC_DETECTIONS_LIST_REQ = 'IOC_DETECTIONS_LIST_REQ'
export const IOC_DETECTIONS_LIST_SUCCESS = 'IOC_DETECTIONS_LIST_SUCCESS'
export const IOC_DETECTIONS_LIST_ERROR = 'IOC_DETECTIONS_LIST_ERROR'
export const IOC_DETECTIONS_LIST_RESET_STATUS = 'IOC_DETECTIONS_LIST_RESET_STATUS'

export const PRIVILEGED_ACTIONS_LIST_SET = 'PRIVILEGED_ACTIONS_LIST_SET'
export const PRIVILEGED_ACTIONS_LIST_REQ = 'PRIVILEGED_ACTIONS_LIST_REQ'
export const PRIVILEGED_ACTIONS_LIST_SUCCESS = 'PRIVILEGED_ACTIONS_LIST_SUCCESS'
export const PRIVILEGED_ACTIONS_LIST_ERROR = 'PRIVILEGED_ACTIONS_LIST_ERROR'
export const PRIVILEGED_ACTIONS_LIST_RESET_STATUS = 'PRIVILEGED_ACTIONS_LIST_RESET_STATUS'

export const ALL_IOC_DETECTIONS_LIST_SET = 'ALL_IOC_DETECTIONS_LIST_SET'

export const IOC_DETAILS_SET = 'IOC_DETAILS_SET'
export const IOC_DETAILS_REQ = 'IOC_DETAILS_REQ'
export const IOC_DETAILS_SUCCESS = 'IOC_DETAILS_SUCCESS'
export const IOC_DETAILS_ERROR = 'IOC_DETAILS_ERROR'
export const IOC_DETAILS_RESET_STATUS = 'IOC_DETAILS_RESET_STATUS'

export const TRAIL_IOCS_SET = 'TRAIL_IOCS_SET'
export const TRAIL_IOCS_REQ = 'TRAIL_IOCS_REQ'
export const TRAIL_IOCS_SUCCESS = 'TRAIL_IOCS_SUCCESS'
export const TRAIL_IOCS_ERROR = 'TRAIL_IOCS_ERROR'
export const TRAIL_IOCS_RESET_STATUS = 'TRAIL_IOCS_RESET_STATUS'

export const IOC_LIST_RANGE_SET = 'IOC_LIST_RANGE_SET'
export const IOC_LIST_RANGE_REQ = 'IOC_LIST_RANGE_REQ'
export const IOC_LIST_RANGE_SUCCESS = 'IOC_LIST_RANGE_SUCCESS'
export const IOC_LIST_RANGE_ERROR = 'IOC_LIST_RANGE_ERROR'
export const IOC_LIST_RANGE_RESET_STATUS = 'IOC_LIST_RANGE_RESET_STATUS'

export const PRIVILEGED_IOC_LIST_RANGE_SET = 'PRIVILEGED_IOC_LIST_RANGE_SET'
export const PRIVILEGED_IOC_LIST_RANGE_REQ = 'PRIVILEGED_IOC_LIST_RANGE_REQ'
export const PRIVILEGED_IOC_LIST_RANGE_SUCCESS = 'PRIVILEGED_IOC_LIST_RANGE_SUCCESS'
export const PRIVILEGED_IOC_LIST_RANGE_ERROR = 'PRIVILEGED_IOC_LIST_RANGE_ERROR'
export const PRIVILEGED_IOC_LIST_RANGE_RESET_STATUS = 'PRIVILEGED_IOC_LIST_RANGE_RESET_STATUS'

export const IOC_DAILY_ACTIVITY_SET = 'IOC_DAILY_ACTIVITY_SET'
export const IOC_DAILY_ACTIVITY_REQ = 'IOC_DAILY_ACTIVITY_REQ'
export const IOC_DAILY_ACTIVITY_SUCCESS = 'IOC_DAILY_ACTIVITY_SUCCESS'
export const IOC_DAILY_ACTIVITY_ERROR = 'IOC_DAILY_ACTIVITY_ERROR'
export const IOC_DAILY_ACTIVITY_RESET_STATUS = 'IOC_DAILY_ACTIVITY_RESET_STATUS'

export const PRIVILEGED_IOC_DAILY_ACTIVITY_SET = 'PRIVILEGED_IOC_DAILY_ACTIVITY_SET'
export const PRIVILEGED_IOC_DAILY_ACTIVITY_REQ = 'PRIVILEGED_IOC_DAILY_ACTIVITY_REQ'
export const PRIVILEGED_IOC_DAILY_ACTIVITY_SUCCESS = 'PRIVILEGED_IOC_DAILY_ACTIVITY_SUCCESS'
export const PRIVILEGED_IOC_DAILY_ACTIVITY_ERROR = 'PRIVILEGED_IOC_DAILY_ACTIVITY_ERROR'
export const PRIVILEGED_IOC_DAILY_ACTIVITY_RESET_STATUS = 'PRIVILEGED_IOC_DAILY_ACTIVITY_RESET_STATUS'

export const IOC_TACTIC_SUMMARY_SET = 'IOC_TACTIC_SUMMARY_SET'
export const IOC_TACTIC_SUMMARY_REQ = 'IOC_TACTIC_SUMMARY_REQ'
export const IOC_TACTIC_SUMMARY_SUCCESS = 'IOC_TACTIC_SUMMARY_SUCCESS'
export const IOC_TACTIC_SUMMARY_ERROR = 'IOC_TACTIC_SUMMARY_ERROR'
export const IOC_TACTIC_SUMMARY_RESET_STATUS = 'IOC_TACTIC_SUMMARY_RESET_STATUS'

export const ACCOUNT_KEY_IOCS_SET = 'ACCOUNT_KEY_IOCS_SET'
export const ACCOUNT_KEY_IOCS_REQ = 'ACCOUNT_KEY_IOCS_REQ'
export const ACCOUNT_KEY_IOCS_SUCCESS = 'ACCOUNT_KEY_IOCS_SUCCESS'
export const ACCOUNT_KEY_IOCS_ERROR = 'ACCOUNT_KEY_IOCS_ERROR'
export const ACCOUNT_KEY_IOCS_RESET_STATUS = 'ACCOUNT_KEY_IOCS_RESET_STATUS'

export const MULTIPLE_ACCOUNT_KEY_IOCS_SET = ' MULTIPLE_ACCOUNT_KEY_IOCS_SET'
export const MULTIPLE_ACCOUNT_KEY_IOCS_REQ = ' MULTIPLE_ACCOUNT_KEY_IOCS_REQ'
export const MULTIPLE_ACCOUNT_KEY_IOCS_SUCCESS = ' MULTIPLE_ACCOUNT_KEY_IOCS_SUCCESS'
export const MULTIPLE_ACCOUNT_KEY_IOCS_ERROR = ' MULTIPLE_ACCOUNT_KEY_IOCS_ERROR'
export const MULTIPLE_ACCOUNT_KEY_IOCS_RESET_STATUS = ' MULTIPLE_ACCOUNT_KEY_IOCS_RESET_STATUS'

export const DETECTIONS_VIEW_PREFERENCES_REQ = 'DETECTIONS_VIEW_PREFERENCES_REQ'
export const SAVE_DETECTIONS_VIEW_PREFERENCES = 'SAVE_DETECTIONS_VIEW_PREFERENCES'



// WEBPACK FOOTER //
// ./src/store/modules/detections/detections.type.js